// PricingConfigurator.jsx
import React, { useState } from "react";
import "./PricingConfigurator.css";

const pricing = [
    { users: 1, prices: [15.00, 24.57, 30.71, 38.39, 47.99, 59.99] },
    { users: 2, prices: [15.00, 23.31, 29.14, 36.42, 45.53, 56.91] },
    { users: 3, prices: [15.00, 22.17, 27.72, 34.65, 43.31, 54.13] },
    { users: 4, prices: [15.00, 21.14, 26.43, 33.03, 41.29, 51.62] },
    { users: 5, prices: [15.00, 20.2, 25.25, 31.57, 39.46, 49.32] },
    { users: 6, prices: [15.00, 19.34, 24.18, 30.22, 37.78, 47.22] },
    { users: 7, prices: [15.00, 18.55, 23.19, 28.99, 36.24, 45.3] },
    { users: 8, prices: [15.00, 17.83, 22.28, 27.85, 34.82, 43.52] },
    { users: 9, prices: [15.00, 17.15, 21.44, 26.8, 33.5, 41.88] },
    { users: 10, prices: [15.00, 16.53, 20.66, 25.83, 32.28, 40.35] },
];

const storageOptions = ["10 Go", "50 Go", "100 Go", "250 Go", "500 Go", "1 To"];

const PricingConfigurator = () => {
    const [numUsers, setNumUsers] = useState(1);
    const [storageIndex, setStorageIndex] = useState(0);

    const priceBase =
        pricing.find(p => p.users === numUsers)?.prices[storageIndex] ?? 0;

    // 💰 +15 € pour chaque utilisateur supplémentaire
    const price = priceBase + (numUsers - 1) * 15;

    return (
        <div className="configurator">
            <h2 className="section-title">Simulateur de tarif Drive</h2>

            <div className="slider-container">
                <label>Utilisateurs : {numUsers}</label>
                <input
                    type="range"
                    min="1"
                    max="10"
                    value={numUsers}
                    onChange={e => setNumUsers(parseInt(e.target.value))}
                    className="sliderr"
                />
                <span className="slider-value">{numUsers}</span>
            </div>

            <div className="slider-container">
                <label>Stockage : {storageOptions[storageIndex]}</label>
                <input
                    type="range"
                    min="0"
                    max={storageOptions.length - 1}
                    value={storageIndex}
                    onChange={e => setStorageIndex(parseInt(e.target.value))}
                    className="sliderr"
                />
                <span className="slider-value">{storageOptions[storageIndex]}</span>
            </div>

            <div className="price-box">
                <span>Prix total </span>
                <strong>{price.toFixed(2)} € HT</strong>
            </div>
        </div>
    );
};

export default PricingConfigurator;
